import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ObbligoProvider } from 'src/app/services/obbligo.provider';

@Component({
  selector: 'app-webcontent-publisher',
  templateUrl: './webcontent-publisher.component.html',
  styleUrls: ['./webcontent-publisher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebcontentPublisherComponent implements OnInit {

  data!: any | undefined;
  content: string = '';

  constructor() { }

  ngOnInit(): void {
    this.content = this.data.data.map((webcontent: any) => webcontent.content);
  }

}
